import { CorporationDetails, LoginResponse } from '@/types';

const CHANNEL_NAME = 'aura:session';

export type messagePayload = SwitchPayload | LoginPayload | LogoutPayload | ChangePayload;

export type SwitchPayload = {
    type: 'switch';
    data: CorporationDetails;
};

export type LoginPayload = {
    type: 'login';
    data: LoginResponse;
};

export type LogoutPayload = {
    type: 'logout';
    data?: unknown;
};

export type ChangePayload = {
    type: 'change';
    data: CorporationDetails;
};

export class SyncSessionService {
    private static channel = new BroadcastChannel(CHANNEL_NAME);

    static postMessage = (payload: messagePayload) => {
        this.channel.postMessage(payload);
    };
    static subscribe = (handler: (payload: messagePayload) => void) => {
        const onMessage = (event: MessageEvent<messagePayload>) => {
            handler(event.data);
        };
        this.channel.addEventListener('message', onMessage);

        return () => {
            this.channel.removeEventListener('message', onMessage);
        };
    };
}
